import React, { useEffect, useState } from 'react';
import { GoodsProps } from '../api/Goods';
import { GoodsItemView } from './GoodsItemView';
import { GoodsItemEdit } from './GoodsItemEdit';

export type GoodsItemProps = {
  isNew?: boolean;
  article?: string;
  data?: GoodsProps;
  onCreate?: (props: GoodsProps) => void;
  onUpdate?: (props: GoodsProps) => void;
  onDelete?: (article: string) => void;
  onRestore?: (article: string) => void;
  brands: { name: string }[];
  productCategories: { id: number; name: string }[];
  availableTags: { id: number; name: string }[];
  onTagsCatalogChange?: () => void;
};

const defaultValues: GoodsProps = {
  article: '',
  name: '',
  category: null,
  brand: null,
  is_combo: false,
  comboComposition: [],
  wb_data: null,
  ozon_data: null,
  ya_data: null,
  sber_data: null,
  ali_data: null,
  tags: [],
};

// Основной компонент
export const GoodsItem = ({
  isNew,
  data = defaultValues,
  ...props
}: GoodsItemProps) => {
  const [edit, setEdit] = useState(isNew);
  const [localData, setLocalData] = useState(data);

  useEffect(() => {
    setLocalData(data);
    if (!isNew) {
      setEdit(false);
    }
  }, [data, isNew]);

  const handleSave = async (savedData: GoodsProps) => {
    try {
      if (isNew && props.onCreate) {
        await props.onCreate(savedData);
      } else if (props.onUpdate) {
        await props.onUpdate(savedData);
        setEdit(false);
      }
    } catch (error) {
      // Ошибка будет обработана в GoodsItemEdit
      throw error;
    }
  };

  const handleDelete = () => {
    const result = window.confirm('Действительно хотите удалить?');
    if (!result || !props.onDelete) return;
    props.onDelete(localData.article);
  };

  if (!edit) {
    return (
      <GoodsItemView
        data={localData}
        onEdit={() => setEdit(true)}
        onDelete={
          !localData.deleted_at && props.onDelete ? handleDelete : undefined
        }
        onRestore={
          props.onRestore && localData.deleted_at
            ? () => props.onRestore!(localData.article)
            : undefined
        }
      />
    );
  }

  return (
    <GoodsItemEdit
      isNew={isNew || false}
      data={localData}
      brands={props.brands}
      productCategories={props.productCategories}
      availableTags={props.availableTags}
      onTagsCatalogChange={props.onTagsCatalogChange}
      onSave={handleSave}
      onCancel={!isNew ? () => setEdit(false) : undefined}
      onDelete={!isNew ? handleDelete : undefined}
    />
  );
};
